






















































































































































































import { Component, Prop, Mixins, Inject } from "vue-property-decorator";
import {
  IContractProduct,
  IContractProductSettingsForm
} from "@/models/contracts";
import { DataModules } from "@/store/modules/data";
import Context from "@/mixins/context";
import HasValidation from "@/mixins/HasValidation";
import RequestPromises from "@/mixins/requestPromises";
import {
  IContractProductProvider,
  IContractProductProviderMethods
} from "@/models/providers/contractProduct";

@Component({
  components: {
    "payment-method-vessel": () =>
      import("@/components/app/global/payments/paymentMethodVessel.vue"),
    "recurring-due-date-control": () =>
      import("@/components/app/global/invoices/recurringDueDateControl.vue"),
    "invoice-generation-control": () =>
      import("@/components/app/global/invoices/invoiceGenerationControl.vue"),
    "automation-intervals-control": () =>
      import(
        "@/components/app/global/client/contractProducts/automationIntervalsControl.vue"
      ),
    "cprod-cancellation-request": () =>
      import(
        "@/components/app/global/contractProducts/cProdCancellationRequest.vue"
      ),
    "change-company-or-address": () =>
      import(
        "@/components/app/global/contractProducts/changeCompanyOrAddress.vue"
      ),
    "cprod-auto-expire-msg": () =>
      import("@/components/app/global/contractProducts/cProdAutoExpireMsg.vue"),
    "cprod-auto-renew-msg": () =>
      import("@/components/app/global/contractProducts/cProdAutoRenewMsg.vue")
  }
})
export default class ContractProductSettings extends Mixins(
  RequestPromises,
  Context,
  HasValidation
) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => IContractProductProvider;

  @Inject({ from: "contractProductProviderMethods" })
  public readonly $cProdMethods!: IContractProductProviderMethods;

  // Props

  @Prop({ required: true })
  public productId!: IContractProduct["id"];

  public isProcessing = false;

  public form = {
    payment_days_term: 0,
    create_invoice_term: 0
  } as IContractProductSettingsForm;

  public automationIntervalsForm = {
    suspend_interval: 0,
    close_interval: 0,
    cancel_interval: 0
  } as any;

  public changeCompanyOrAddressForm = {
    company_id: 0,
    address_id: 0
  } as any;

  public formClone: IContractProductSettingsForm = {} as IContractProductSettingsForm;
  public automationIntervalsFormClone = {};
  public changeCompanyOrAddressFormClone = {};

  public mounted() {
    if (!this.cProdData.canModifySettings) {
      // $nextTick prevents ValidationObserver console error
      this.$nextTick(() => {
        this.$route.matched.splice(-1);
        const parent = this.$_.last(this.$route.matched);
        this.$router.replace({ name: parent?.name }).catch(err => err);
      });
    }
  }

  public async created() {
    this.form = this.$_.pick(this.cProdData.contractProduct, [
      "payment_days_term",
      "create_invoice_term"
    ]);

    this.automationIntervalsForm = this.$_.pick(
      this.cProdData.contractProduct,
      ["suspend_interval", "cancel_interval", "close_interval"]
    );

    this.setCompanyOrAddressForm();

    this.formClone = this.$_.clone(this.form);
    this.automationIntervalsFormClone = this.$_.clone(
      this.automationIntervalsForm
    );
  }

  // Getters
  public get cProdData() {
    return this.$cProdData();
  }

  public openChangePaymentMethodModal() {
    this.$cProdMethods.openChangePaymentMethodModal({ parent: this });
  }

  public revertToInitialState() {
    this.form = this.$_.clone(this.formClone);
    this.automationIntervalsForm = this.$_.clone(
      this.automationIntervalsFormClone
    );

    this.changeCompanyOrAddressForm = this.$_.clone(
      this.changeCompanyOrAddressFormClone
    );
  }

  public setCompanyOrAddressForm() {
    this.changeCompanyOrAddressForm = this.$_.pick(this.cProdData.contract, [
      "company_id",
      "address_id"
    ]);
    this.changeCompanyOrAddressFormClone = this.$_.clone(
      this.changeCompanyOrAddressForm
    );
  }

  public async refreshContract() {
    await this.$cProdMethods.reloadData();
    this.setCompanyOrAddressForm();
  }

  public validateBeforeSubmit() {
    this.isProcessing = true;
    this.validate()
      .then(async result => {
        const promises: any = [];
        if (result) {
          if (this.hasChangedAutomationIntervals && this.isAdmin)
            promises.push(this.updateAutomationIntervals());
          if (this.hasChange && this.isAdmin)
            promises.push(this.updateCProdTerms());
          if (this.hasChangedCompanyOrAddress)
            promises.push(this.updateCompanyOrAddress());
          return Promise.all(promises);
        }
        throw this.$t("_sentence.form_is_not_valid");
      })
      .then(() => {
        this.$cProdMethods.reloadData();
        this.$buefy.toast.open({
          message: this.$t("_.object_successfully_updated", {
            object: this.$t("_.contract")
          }) as string
        });

        // Clone forms again
        this.formClone = this.$_.clone(this.form);
        this.automationIntervalsFormClone = this.$_.clone(
          this.automationIntervalsForm
        );
        this.changeCompanyOrAddressFormClone = this.$_.clone(
          this.changeCompanyOrAddressForm
        );
      })
      .catch(error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      })
      .finally(() => (this.isProcessing = false));
  }

  public get formIsDisabled() {
    return (
      this.isProcessing ||
      (!this.hasChange &&
        !this.hasChangedAutomationIntervals &&
        !this.hasChangedCompanyOrAddress) ||
      this.hasErrors
    );
  }

  public get hasChangedAutomationIntervals() {
    return !this.$_.isEqual(
      this.automationIntervalsForm,
      this.automationIntervalsFormClone
    );
  }

  public get hasChangedCompanyOrAddress() {
    return !this.$_.isEqual(
      this.changeCompanyOrAddressForm,
      this.changeCompanyOrAddressFormClone
    );
  }

  public get hasChange() {
    return !this.$_.isEqual(this.form, this.formClone);
  }

  public updateCProdTerms() {
    return this.$store.dispatch(
      `data/${DataModules.CONTRACTS_PRODUCTS}/updateTerms`,
      {
        contractId: this.cProdData.contractId,
        contractProductId: this.cProdData.contractProduct.id,
        data: this.form
      }
    );
  }

  public updateAutomationIntervals() {
    return this.$cProdMethods.changeDates(
      this.automationIntervalsForm,
      () => ({})
    );
  }

  public updateCompanyOrAddress() {
    if (!this.hasChangedCompanyOrAddress) return;
    return this.$cProdMethods.changeAddressOrCompany(
      this.changeCompanyOrAddressForm
    );
  }
}
